import React, { useState } from 'react';

const Toggle = (props) => {
  const [isChecked, setChecked] = useState(props.isChecked || false);

  const handleChange = () => {
    props.onChange(!isChecked);
    setChecked(!isChecked);
  }
    return (
      <label className="switch">
        <input
            type="checkbox"
            value={isChecked}
            onChange={handleChange}
            name={props.name || ''}
        />
        <div className="slider" />
      </label>
    );
}

export default Toggle;